import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative bg-brand-cream pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-81">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-82">
          <div className="max-w-2xl" data-id="element-83">
            <FadeIn data-id="element-84">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-charcoal leading-tight mb-6" data-id="element-85">
                El Sistema de Triple Filtro:{' '}
                <span className="text-brand-gold italic font-normal" data-id="element-86">
                  De Asistente Saturada a VA de 6 Figuras
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-87">
              <h2 className="text-lg md:text-xl text-brand-charcoal/80 font-medium mb-8 leading-relaxed" data-id="element-88">
                Domina la agenda de clientes de alto ticket en USA y recupera tu
                tiempo sin arriesgar tus ingresos.
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-89">
              <div className="prose prose-lg text-brand-charcoal/70 mb-10 border-l-2 border-brand-gold pl-6" data-id="element-90">
                <p className="mb-4" data-id="element-91">
                  <strong data-id="element-92">Son las 11:45 PM.</strong> Tu cliente acaba de enviar
                  un mensaje "urgente" por WhatsApp y sientes ese nudo familiar
                  en el estómago. Sabes que si no respondes ahora, parecerá que
                  no te importa. Pero si respondes, habrás perdido otra noche de
                  descanso por una tarifa que apenas cubre tus facturas.
                </p>
                <p data-id="element-93">
                  No eres una asistente; eres una apagafuegos profesional que se
                  está quedando sin combustible. Y el problema no es tu falta de
                  capacidad, es que estás operando con un sistema diseñado para
                  cobrar $15 la hora, no para liderar un negocio de servicios
                  premium.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-94">
              <Button className="w-full sm:w-auto" onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-95">
                Quiero mi agenda de 6 figuras ahora
              </Button>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-96">
            <div className="relative rounded-sm overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-square" data-id="element-97">
              <div className="absolute inset-0 bg-brand-gold/10 mix-blend-multiply z-10" data-id="element-98"></div>
              <img src="https://cdn.magicpatterns.com/uploads/voU6j4pmyEftdnt1zDUEE8/agenda_de_asistente_virtual.png" alt="Agenda de la Asistente Virtual 6-Figuras en iPad, Laptop y iPhone" className="absolute inset-0 w-full h-full object-cover" data-id="element-99" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-2 border-r-2 border-brand-gold z-0" data-id="element-100"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 border-t-2 border-l-2 border-brand-gold z-0" data-id="element-101"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}